import fileValidate from 'helpers/validates/file'
import fileFormatter from 'helpers/formatters/file'
import getCount from 'helpers/file/getCount'

import validations from 'constants/validations'

const { FILE_GROUPS, MIXED_SCHEMA_TYPE } = validations

const resolveFileTypes = (options) => {
  if (options.types || options.mimeTypes) {
    return { types: options.types, mimeTypes: options.mimeTypes }
  }

  return FILE_GROUPS[options.fileGroup ?? 'all']
}

// Um valor pode misturar File novo (recém-selecionado) com objeto já salvo
// vindo da API (ex: { url, name }) — só o File novo entra na checagem de
// tamanho/tipo, o objeto da API passa direto (quem filtra o que é de fato
// enviado ao backend é a função helper de envio da solicitação, não este método).
const getNewFiles = (value) => {
  if (!value) return []

  const list =
    value instanceof FileList || Array.isArray(value)
      ? Array.from(value)
      : [value]

  return list.filter((file) => file instanceof File)
}

const fileUpload = {
  name: 'fileUpload',
  schemaType: MIXED_SCHEMA_TYPE,
  method(options = {}) {
    const { types, mimeTypes } = resolveFileTypes(options)
    const sizeLimit = options.sizeLimit ?? 10
    const unit = options.unit ?? 'MB'
    const uniqueFilenames = options.uniqueFilenames ?? true
    const requiredMessage =
      options.requiredMessage ?? 'Selecione ao menos um arquivo'
    const { minFiles, maxFiles } = options

    const schema = this.test(
      'fileSize',
      options.sizeMessage ??
        `O arquivo deve ter no máximo ${sizeLimit} ${unit}`,
      (value) => {
        const newFiles = getNewFiles(value)
        return (
          newFiles.length === 0 || fileValidate.size(unit, sizeLimit, newFiles)
        )
      },
    )
      .test(
        'fileType',
        options.typeMessage ??
          `Somente arquivos ${fileFormatter.allowedTypes(
            types,
          )} são permitidos`,
        (value) => {
          const newFiles = getNewFiles(value)
          return newFiles.length === 0 || fileValidate.type(mimeTypes, newFiles)
        },
      )
      .test(
        'uniqueFilenames',
        options.uniqueFilenamesMessage ??
          'Não é permitido enviar arquivos com o mesmo nome',
        (value) => (uniqueFilenames ? fileValidate.uniqueFile(value) : true),
      )
      .test(
        'minFiles',
        options.minFilesMessage ?? `Selecione no mínimo ${minFiles} arquivo(s)`,
        (value) => !minFiles || getCount(value) >= minFiles,
      )
      .test(
        'maxFiles',
        options.maxFilesMessage ??
          `Só é permitido anexar no máximo ${maxFiles} arquivo(s)`,
        (value) => !maxFiles || getCount(value) <= maxFiles,
      )

    if (options.required && typeof options.required === 'object') {
      const requiredCondition = options.required

      return schema.when(requiredCondition.field, {
        is: requiredCondition.is,
        then: (params) =>
          params.test('fileRequired', requiredMessage, (value) =>
            fileValidate.required(value),
          ),
      })
    }

    const required = options.required

    return schema.test('fileRequired', requiredMessage, (value) =>
      required ? fileValidate.required(value) : true,
    )
  },
}

export default fileUpload
